import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { Alert } from '@/components/ui/Alert';
import { Button } from '@/components/ui/Button';
import { Field } from '@/components/ui/Field';
import { describeError, useForgotPassword } from '../api';
import { AuthSwitch } from './AuthDialogParts';
import type { AuthMode } from '../auth-dialog-context';

const schema = z.object({ email: z.email('Geçerli bir e-posta adresi girin.') });

type FormValues = z.infer<typeof schema>;

export function ForgotPasswordForm({ onModeChange }: { onModeChange: (mode: AuthMode) => void }) {
  const forgot = useForgotPassword();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>({ resolver: zodResolver(schema) });

  const onSubmit = handleSubmit((values) => forgot.mutate(values.email));

  if (forgot.isSuccess) {
    return (
      <div className="flex flex-col gap-4 pb-2">
        {/*
          Deliberately says "if an account exists". The API answers identically
          whether or not the address is registered, and a confident "sent!" here
          would leak what the API is careful not to.
        */}
        <Alert tone="success">
          Bu adrese kayıtlı bir hesap varsa sıfırlama bağlantısı gönderildi. Gelen kutunu kontrol
          et.
        </Alert>

        <AuthSwitch question="" action="Giriş ekranına dön" onClick={() => onModeChange('login')} />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-5 pb-2">
      <form onSubmit={(event) => void onSubmit(event)} className="flex flex-col gap-4" noValidate>
        {forgot.isError ? <Alert tone="error">{describeError(forgot.error)}</Alert> : null}

        <Field
          label="E-posta"
          type="email"
          autoComplete="email"
          placeholder="ornek@eposta.com"
          error={errors.email?.message}
          {...register('email')}
        />

        <Button type="submit" loading={forgot.isPending}>
          Sıfırlama bağlantısı gönder
        </Button>
      </form>

      <AuthSwitch question="" action="Giriş ekranına dön" onClick={() => onModeChange('login')} />
    </div>
  );
}
